import { ClientCheckbox } from "../inputs/ClientCheckbox";
export const CheckboxPreview = ({
  update,
  required,
  label,
  default: defaultValue = 'False',
  value = defaultValue,
  id,
  onBlur,
  errors
}) => {
  const checked = value == 'True';
  return <ClientCheckbox id={id} checked={checked} onChange={e => {
    e.target.checked ? update('True') : update('False');
  }} label={label} required={required} error={errors} additionalClass="preview--checkbox" onBlur={onBlur} />;
};